import { useEffect } from 'react'
import { useDioxusWithProps } from '@/lib/wasm'
import type { SearchResourceType } from '@/data/entities'

interface TypeFilterBarProps {
  value: SearchResourceType[]
  onChange: (value: SearchResourceType[]) => void
}

export function TypeFilterBar({ value, onChange }: TypeFilterBarProps) {
  const ref = useDioxusWithProps('mount_type_filter_bar', { value })

  // Listen for toggle-filter clicks from WASM
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const handler = (e: Event) => {
      const btn = (e.target as HTMLElement).closest(
        '[data-action="toggle-filter"]',
      )
      const type = btn?.getAttribute('data-type') as SearchResourceType | null
      if (!type) return
      const newValue = value.includes(type)
        ? value.filter((t) => t !== type)
        : [...value, type]
      onChange(newValue)
    }
    el.addEventListener('click', handler)
    return () => el.removeEventListener('click', handler)
  }, [ref, value, onChange])

  return <div ref={ref} className="contents" />
}
